import type { ImageView } from '@vizit/api';

/**
 * Utility functions for detecting different types of images
 */

/**
 * Determines if the currently selected image is a generated image
 * @param selectedGeneratedImageId - The ID of the currently selected image
 * @param originalAssetId - The ID of the original asset
 * @returns true if viewing a generated image, false if viewing the original
 */
export function isGeneratedImageSelected(selectedGeneratedImageId: string, originalAssetId: string): boolean {
  return selectedGeneratedImageId !== originalAssetId;
}

/**
 * Determines if an image is generated based on its source field
 * @param imageData - The image data object with source field
 * @returns true if the image source is 'generated', false otherwise
 */
export function isGeneratedImageBySource(imageData: ImageView | null | undefined): boolean {
  return imageData?.source === 'generated';
}

/**
 * Determines if an image is user uploaded based on its source field
 * @param imageData - The image data object with source field
 * @returns true if the image source is 'user_uploaded', false otherwise
 */
export function isUserUploadedImage(imageData: ImageView | null | undefined): boolean {
  return imageData?.source === 'user_uploaded';
}

/**
 * Determines if an image is scraped based on its source field
 * @param imageData - The image data object with source field
 * @returns true if the image source is 'scraped', false otherwise
 */
export function isScrapedImage(imageData: ImageView | null | undefined): boolean {
  return imageData?.source === 'scraped';
}
